import axios from '../utils/axios';

export default function updateFeatureAccess (adminId, data) {
    return axios.post(`/admin/${adminId}/update-feature-access`, data);
}